module.exports = __webpack_public_path__ + "media/images/new_home/business-list-photo-423d85e7da6d87357a765d9d0b372b39.jpg";